import React from "react";
import { SortBy, Filters } from "@usereactify/search";

import { FilterList } from "../filter/FilterList";
import { SortBySelector } from "../sortBy/SortBy";
import { GridSizeSelector } from "./GridSizeSelector";
import { Drawer } from "../drawer/Drawer";

interface CollectionToolBarProps {
    setProductsPerRow: (value: string) => void;
    collection?: any
    reactifyLoaded?: boolean
    searchTerm?: string
    results?: number
}

export const CollectionToolBar: React.FC<CollectionToolBarProps> = ({ setProductsPerRow, collection, reactifyLoaded, searchTerm = "", results = 0 }) => {
    const collectionData = window.subCollections;

    const filtersComponent = (
        <Filters
            renderFilterList={FilterList}
        />
    );

    return (
        <div className={`collection-tool-bar__container align-center justify-between ${!reactifyLoaded ? "hidden" : "flex"}`}>
            <div className={`w-full hidden sm:flex ${searchTerm ? "align-center sm:flex" : "flex-col md:flex-row md:gap-6 "}`}>
                <p className="collection-tool-bar__title flex align-center">{collection?.title || searchTerm} <p className={`collection-tool-bar__search-results ${!searchTerm && "hidden"}`}> {results} results for "{searchTerm}" </p></p>
                <div className="collection-tool-bar__menu flex gap-6 align-end">
                    {collectionData &&
                        collectionData.map((collection: any) => (
                            <a href={`${collection.url}`} className="collection-tool-bar__menu-item" key={collection.url}>
                                {collection.title}
                            </a>
                        ))
                    }
                </div>
            </div>
            <div className="collection-tool-bar__sort-filter flex align-center justify-end">
                <GridSizeSelector setProductsPerRow={setProductsPerRow} />

                <div className="sort__container">
                    <SortBy render={(props) => <SortBySelector {...props} />} />
                </div>

                <div className="filter__container flex justify-center">
                    <Drawer title="Filters" buttonPrimaryText="Apply">{filtersComponent}</Drawer>
                </div>
            </div>
        </div>
    );
};
